export default {
  "header": "_header_1avxp0"
};